function required(name: string): string {
  const v = import.meta.env[name];
  if (!v || String(v).trim() === "") {
    throw new Error(`Missing required env var: ${name}`);
  }
  return String(v);
}

export const ENV = {
  VITE_API_URL: required("VITE_API_URL"),
  VITE_TENANT_ID: required("VITE_TENANT_ID"),

  VITE_OAUTH_SERVER_URL: required("VITE_OAUTH_SERVER_URL"),
  VITE_OAUTH_CLIENT_REDIRECT_PATH: required("VITE_OAUTH_CLIENT_REDIRECT_PATH"),
  VITE_OAUTH_LOGIN_URL: required("VITE_OAUTH_LOGIN_URL"),
  VITE_OAUTH_CLIENT_ID: required("VITE_OAUTH_CLIENT_ID"),
  VITE_OAUTH_CLIENT_SCOPE: required("VITE_OAUTH_CLIENT_SCOPE"),

  VITE_SIGNED_OUT_URL: required("VITE_SIGNED_OUT_URL"),

  VITE_SECURE_COOKIES: required("VITE_SECURE_COOKIES") === "true",
} as const;
